import { useRecoilState, useRecoilValue } from 'recoil';

import { userSettingsState, weatherForecastState } from '@store';

import { segmentEventTypes } from '../components/segment/segmentEventTypes';
import { segmentTrackEvent } from '../components/segment/SegmentTrackEvent';

const WEATHER_FORECAST_DATA = {
  DAILY: { FEATURE_ID: 'Daily', SEGMENT_ID: 6 },
  HOURLY: { FEATURE_ID: 'Hourly', SEGMENT_ID: 7 },
  NOW: { FEATURE_ID: 'Now', SEGMENT_ID: 8 },
};

const WEATHER_FORECAST_TYPE = {
  DAILY: 'DAILY',
  HOURLY: 'HOURLY',
  NOW: 'NOW',
};

const WEATHER_FORECAST_EVENT = {
  DAILY: segmentEventTypes.DAILY_FORECAST,
  HOURLY: segmentEventTypes.HOURLY_FORECAST,
  NOW: segmentEventTypes.NOW_FORECAST,
};

export const useSegmentTrackWeatherForecast = () => {
  const [weatherForecastCount, setWeatherForecastCount] = useRecoilState(weatherForecastState);
  const settings = useRecoilValue(userSettingsState);

  const setSegmentTrackWeatherForecast = type => {
    const nextWeatherCount = weatherForecastCount + 1;

    setWeatherForecastCount(nextWeatherCount);

    segmentTrackEvent(WEATHER_FORECAST_EVENT[type], settings, {
      weatherForecast: {
        featureId: WEATHER_FORECAST_DATA[type].FEATURE_ID,
        mwSegmentId: WEATHER_FORECAST_DATA[type].SEGMENT_ID,
        weatherForecastCount: nextWeatherCount,
      },
    });
  };

  return [WEATHER_FORECAST_TYPE, setSegmentTrackWeatherForecast];
};
